export default __webpack_public_path__ + "static/media/gm.b2545303.svg";